const sortableValues = {
  createdAt: 'createdAt',
  invoice  : 'amount',
  code     : 'serviceCode',
};

const getSortArrayValues = sortedList => sortedList
  .map(({ id, desc }) => `${sortableValues[id]}:${desc ? 'desc' : 'asc'}`);

const createSortedValue = (sortedList = []) => {
  const result = getSortArrayValues(sortedList);
  // TODO: improve in case of multiple sort values needed
  // ie: &sorted=username:desc,status:asc
  return (result.length === 0) ? '' : `sorted=${result[0]}`;
};

function getName(id) {
  switch (id) {
    // SERVICES FIELDS
    case 'from.cityCode':
      return 'area';
    case 'code':
      return 'serviceCode';
    case 'status':
      return 'status';
    case 'order.customer.name':
      return 'username';
    // ORDERS FIELDS
    // Could be resellerCompany if prefer to pass a string
    // case 'resellerCompany.code':
    //   return 'resellerCompany';
    case 'resellerCompany.code':
      return 'resellerCompanyId';
    case 'customer.email':
      return 'email';
    case 'customer':
      return 'username';
    default:
      return id;
  }
}

function getParamsFromFiltered(filtered) {
  return filtered.reduce((sum, { value, id }) => (value.includes('_all')
    ? sum
    : `${sum}${sum !== '' ? '&' : ''}${getName(id)}=${value}`),
  '');
}

// ToDo change it to use some lib instead of manually forging the query string
// Change it to create arrays like this: param=value1&param=value2
export function getQueryStringFilter({
  filtered, page, pageSize, sorted, ...other
}) {
  const otherFilters = Object.keys(other).reduce(
    (prev, curr) => {
      prev.push(`${curr}=${other[`${curr}`]}`);
      return prev;
    },
    []
  );
  const params = [
    `limit=${pageSize}`,
    `offset=${page * pageSize}`,
    ...otherFilters,
    createSortedValue(sorted),
    getParamsFromFiltered(filtered),
  ];
  const queryString = params
    .filter(value => value)
    .join('&');
  return queryString;
}
